import React, { useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  TableSortLabel,
  IconButton,
} from '@mui/material'
import { useMediaQuery } from '@mui/material'
import { Search } from '@mui/icons-material'
import api from '../../../config/api'

const PaymentHistory = () => {
  const [payments, setPayments] = useState([])
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState('asc')
  const [showExtraColumns, setShowExtraColumns] = useState(false)

  const isMobile = useMediaQuery('(max-width:768px)') // Проверка разрешения для мобильных

  async function getPayments() {
    let response = await api.get('/API_FRONT/user/payments/')
    setPayments(response?.data?.payments || [])
  }

  useEffect(() => {
    getPayments()
  }, [])

  const handleSort = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
    setSortColumn(column)
    setSortDirection(newDirection)
  }

  const sortedPayments = [...payments].sort((a, b) => {
    if (!sortColumn) return 0

    let compareA = a[sortColumn]
    let compareB = b[sortColumn]

    if (typeof compareA === 'number' && typeof compareB === 'number') {
      return sortDirection === 'asc' ? compareA - compareB : compareB - compareA
    } else if (typeof compareA === 'string' && typeof compareB === 'string') {
      const isNumberA = !isNaN(parseFloat(compareA))
      const isNumberB = !isNaN(parseFloat(compareB))

      if (isNumberA && isNumberB) {
        return sortDirection === 'asc'
          ? parseFloat(compareA) - parseFloat(compareB)
          : parseFloat(compareB) - parseFloat(compareA)
      } else {
        return sortDirection === 'asc'
          ? compareA.localeCompare(compareB)
          : compareB.localeCompare(compareA)
      }
    } else {
      compareA = compareA ? compareA.toString().toLowerCase() : ''
      compareB = compareB ? compareB.toString().toLowerCase() : ''
      return sortDirection === 'asc'
        ? compareA.localeCompare(compareB)
        : compareB.localeCompare(compareA)
    }
  })

  return (
    <Box sx={{ p: 2 }}>
      {isMobile && (
        <IconButton
          onClick={() => setShowExtraColumns(!showExtraColumns)}
          sx={{ mb: 2 }}
        >
          <Search />
        </IconButton>
      )}
      <Table>
        <TableHead>
          <TableRow>
            {!isMobile || showExtraColumns ? (
              <TableCell>
                <TableSortLabel
                  active={sortColumn === 'id'}
                  direction={sortDirection}
                  onClick={() => handleSort('id')}
                >
                  ID
                </TableSortLabel>
              </TableCell>
            ) : null}
            <TableCell>
              <TableSortLabel
                active={sortColumn === 'date'}
                direction={sortDirection}
                onClick={() => handleSort('date')}
              >
                Дата
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sortColumn === 'amount'}
                direction={sortDirection}
                onClick={() => handleSort('amount')}
              >
                Сумма
              </TableSortLabel>
            </TableCell>
            {!isMobile || showExtraColumns ? (
              <TableCell>
                <TableSortLabel
                  active={sortColumn === 'method'}
                  direction={sortDirection}
                  onClick={() => handleSort('method')}
                >
                  Способ
                </TableSortLabel>
              </TableCell>
            ) : null}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedPayments.map((payment) => (
            <TableRow key={payment.id}>
              {!isMobile || showExtraColumns ? (
                <TableCell>{payment.id}</TableCell>
              ) : null}
              <TableCell>
                {new Date(payment.date).toLocaleString('ru-RU', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </TableCell>
              <TableCell>{payment.total}</TableCell>
              {!isMobile || showExtraColumns ? (
                <TableCell>{payment.types}</TableCell>
              ) : null}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default PaymentHistory
